import { Component, Input } from '@angular/core';

@Component({
  selector: 'orgbrain-orgbrain-logo',
  templateUrl: './orgbrain-logo.component.html',
    standalone: false
})
export class OrgbrainLogoComponent {
  @Input() transform = '';
}
